import type { HqControlResult, HqControlSource } from '@kop/contracts';

export const hazardReportColumns = [
  {key:'assessed',label:'평가건수'}, {key:'plans',label:'감소대책 수립건수'},
  {key:'completed',label:'조치건수'}, {key:'scheduled',label:'조치예정'}, {key:'unresolved',label:'미조치'},
] as const;
const kinds = [['regular-risk','정기 위험성평가'],['work-permit','수시 위험성평가'],['inspection-reporting','점검·조치']] as const;
export type HazardReportRow = {siteId:string;siteName:string;featureId:string;label:string;source:HqControlSource | null};
export function hazardReportRows(data:HqControlResult | null,siteId:string) {
  return data?.sites.filter(site=>siteId==='all'||site.id===siteId).flatMap(site=>kinds.map(([featureId,label])=>({siteId:site.id,siteName:site.name,featureId,label,
    source:site.sources.find(source=>source.topicId==='hazard-improvement'&&source.featureId===featureId)??null})))??[];
}
export function hazardReportValue(row:HazardReportRow,key:string,period:string) {
  if (!row.source || !['saved','partial'].includes(row.source.state)) return null;
  const metrics=row.source.metrics.filter(metric=>metric.key===key&&metric.period===period&&metric.unit==='건');
  return metrics.length===1&&Number.isSafeInteger(metrics[0]!.value)&&Number(metrics[0]!.value)>=0?metrics[0]!.value:null;
}
export function hazardReportTotals(rows:readonly HazardReportRow[],period:string) {
  return hazardReportColumns.map(column=>{
    const values=rows.map(row=>hazardReportValue(row,column.key,period));
    const known=values.filter((value):value is number=>value!==null);
    return {...column,value:known.length?known.reduce((sum,value)=>sum+value,0):null,
      complete:rows.length>0&&rows.every((row,index)=>row.source?.state==='saved'&&values[index]!==null)};
  });
}
